import { Divider, Modal, Button } from "antd";
import React from "react";
import { FeatureGroup, MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { useSelector, useDispatch } from "react-redux";
import { selectLicenseList, setIntersectionResultModal } from "../../api/redux";
import * as worldAnimation from "../../../../animations/69023-world-map-blue.json";
import Lottie from "react-lottie";

export default (props) => {
  const state = useSelector(selectLicenseList);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(setIntersectionResultModal(false));
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: worldAnimation.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  console.log("aaaaaaaaaa", state.intersectionLength);

  return (
    <Modal
      title="محدویت ها"
      className="as-modal p-0"
      footer={false}
      width={"60%"}
      visible={state.intersectionResultModal}
      onCancel={onClose}
    >
      <div className="d-flex flex-wrap p-2">
        {state.intersectionStatus === "idle" && state.intersectionResult ? (
          <>
            {state.intersectionResult.filter((ve) => {
              return ve.spanData.length !== 0;
            }).length === 0 ? (
              <h6 className="my-3">محدودیتی با محصول موردنظر یافت نشد</h6>
            ) : (
              <>
                {state.intersectionResult.map((el) => {
                  return (
                    <>
                      {el.spanData.length !== 0 && (
                        <div
                          className="col-12 d-flex flex-column"
                          style={{ gap: "5px" }}
                        >
                          <div className="d-flex flex-wrap text-right">
                            {el.incidentTitle && (
                              <div className="col-6  mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  پیشامد
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">
                                  {el.incidentTitle}
                                </h5>
                              </div>
                            )}
                            {el.answer && (
                              <div className="col-6  mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  پاسخ
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">{el.answer}</h5>
                              </div>
                            )}
                            {el.layerTitle && (
                              <div className="col-6 mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  لایه
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">{el.layerTitle}</h5>
                              </div>
                            )}
                            {el.productTitle && (
                              <div className="col-6  mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  محصول
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">
                                  {el.productTitle}
                                </h5>
                              </div>
                            )}
                            {el.layerTypeTitle && (
                              <div className="col-6  mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  نوع اراضی
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">
                                  {el.layerTypeTitle}
                                </h5>
                              </div>
                            )}
                            {el.layerUsageTitle && (
                              <div className="col-6  mt-2 ">
                                <span
                                  style={{ color: "#6c6c6c", fontSize: "15px" }}
                                >
                                  کاربری اراضی
                                </span>
                                <br />
                                <h5 className="mt-1 lh-30">
                                  {el.layerUsageTitle}
                                </h5>
                              </div>
                            )}
                          </div>
                          <div style={{ height: "14rem" }}>
                            <MapContainer
                              bounds={
                                state.province.spanData.type === "MultiPolygon"
                                  ? state.province?.spanData?.coordinates[0][0].map(
                                      (el) => {
                                        return [el[1], el[0]];
                                      }
                                    )
                                  : state.province?.spanData?.coordinates[0].map(
                                      (el) => {
                                        return [el[1], el[0]];
                                      }
                                    )
                              }
                              className="h-100"
                            >
                              <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                key={1}
                              />
                              <FeatureGroup>
                                {state.province && (
                                  <GeoJSON
                                    data={state.province?.spanData}
                                    style={{ color: "lightblue" }}
                                  />
                                )}

                                {el?.spanData &&
                                  el.spanData.map((coor) => {
                                    return <GeoJSON data={coor.spanData} />;
                                  })}
                              </FeatureGroup>
                            </MapContainer>
                          </div>
                          <Divider className="w-100" />
                        </div>
                      )}
                    </>
                  );
                })}
              </>
            )}
          </>
        ) : (
          <>
            {state.intersectionStatus === "loading" ? (
              <Lottie options={defaultOptions} height={"100%"} width={"75%"} />
            ) : (
              <>
                {state.intersectionLength &&
                  state.intersectionLength.length === 0 && (
                    <h6 className="my-auto p-3">داده ای یافت نشد</h6>
                  )}
              </>
            )}
          </>
        )}
        <div className="col-12">
          <Button
            className="w-100"
            onClick={() => {
              dispatch(setIntersectionResultModal(false));
            }}
            style={{ height: "3rem" }}
          >
            <h6 className="my-auto">بستن</h6>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
